// API
export const GET_AGREEMENTS_API = 'agreements/type';

// Queries
export const QUERY_REGISTER_AGREEMENTS = 'QUERY_REGISTER_AGREEMENTS';
export const QUERY_PAYMENT_AGREEMENTS = 'QUERY_PAYMENT_AGREEMENTS';
export const QUERY_COOKIES_AGREEMENTS = 'QUERY_COOKIES_AGREEMENTS';
export const QUERY_LOYALTY_AGREEMENTS = 'QUERY_LOYALTY_AGREEMENTS';
